export const ZONE_HEIGHT = 48;

export const BAR_WIDTH_RATIO = 0.6;

export const MIN_BAR_HEIGHT_PERCENT = 2;
